const NotFound = () => {
    return (
        <div className="form-background">
            <h1 className="home-title"><span>4</span>0<span>4</span><br /><span>p</span>a<span>g</span>e <span>i</span>n<span>d</span>i<span>s</span>p<span>o</span>n<span>i</span>b<span>l</span>e</h1>
        </div>
    )
}

export default NotFound